import React, {PureComponent, ReactNode} from 'react';
import UserPromotion from 'app/components/user/UserPromotion';
import {getPromoUrl} from 'app/utils/getPromoUrl';
import {userStore} from 'app/store/global';
import {USER_PROMOTION_DEPOSIT, USER_PROMOTION_FRIEND, USER_PROMOTION_DISCONT} from 'app/utils/Consts';

interface UserPromotionsProps {
    onClose?: () => void;
}

class UserPromotions extends PureComponent<UserPromotionsProps> {
    render(): ReactNode {
        return <div className="user-promotions">
            {!userStore.user.first_deposit && !userStore.user.bonuses_disabled && <UserPromotion
                linkUserPromotion="/deposits"
                itemClassName="promotion-first-deposit"
                localePromotionTitle="user_promotion.first_deposit_title"
                svgIconName="first-deposit"
                localePromotionText="user_promotion.first_deposit_text"
                bannerType="promo"
                nameCoockie={USER_PROMOTION_DEPOSIT}
                showClose
                onClose={this.props.onClose}
            />}
            <UserPromotion
                linkUserPromotion="/my_profile/referrals"
                itemClassName="invite-friend"
                localePromotionTitle="user_promotion_invite_title"
                svgIconName="plus"
                localePromotionText="user_promotion_invite_text"
                bannerType="referral"
                nameCoockie={USER_PROMOTION_FRIEND}
                showClose
                onClose={this.props.onClose}
            />
            {!userStore.user.bonuses_disabled && <UserPromotion
                linkUserPromotion={getPromoUrl()}
                itemClassName="promotion-discount"
                localePromotionTitle="user_promotion_discount_title"
                svgIconName="discount"
                localePromotionText="user_promotion_discount_text"
                bannerType="promo"
                nameCoockie={USER_PROMOTION_DISCONT}
                showClose
                onClose={this.props.onClose}
            />}
        </div>;
    }
}

export default UserPromotions;
